export default __webpack_public_path__ + "static/media/image-study-admin-w.508361d3.webp";